/* @flow weak */
import Link from 'components/Link.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import React from 'react';
import ReportToRemindSelectModal, { DEFAULT_OPTIONS } from 'support/components/ReportToRemindSelectModal.jsx';
import OrganizationActions from 'actions/OrganizationActions';
import ToastActions from 'actions/ToastActions';

import './styles/ReportOrgUserModal.scss';

const ReportOrgUserModal = React.createClass({

  propTypes: {
    userName: React.PropTypes.string.isRequired,
    userId: React.PropTypes.number.isRequired,
    orgName: React.PropTypes.string.isRequired,
    orgId: React.PropTypes.number.isRequired,
    removeModal: React.PropTypes.func.isRequired,
  },

  onCancel() {
    this.props.onRequestHide();
  },

  onReport(reason, notes) {
    const onSuccess = () => {
      ToastActions.showSuccessToast('Report submitted');
      this.props.onRequestHide();
    };

    const onError = function() {
      ToastActions.showErrorToast('Something went wrong. Please try again.');
    };

    OrganizationActions
      .reportUserAsAdmin(this.props.orgId, this.props.userId, reason, notes)
      .then(onSuccess, onError);
  },

  render() {
    const placeholder = 'Please explain why you are reporting this person to Remind.';
    const options = DEFAULT_OPTIONS.concat([
      'No longer at this school',
    ]);
    const title = 'Report to Remind';

    return (
      <ReportToRemindSelectModal
        {...this.props}
        title={title}
        buttonText="Report"
        notesRequired
        options={options}
        reportee={this.props.userName}
        notesPlaceholder={placeholder}
        onReport={this.onReport}>
        <p className="ReportOrgUserModal-info">
          If {this.props.userName} is erroneously linked to
          {' '}
          {this.props.orgName}, please
          {' '}
          <ModalTrigger
            modal={this.props.removeModal(this.props.userName, this.props.userId)}>
            <Link
              className="ReportOrgUserModal-remove"
              onClick={this.onCancel}
              eventElementName="ReportOrgUserModal-remove">
              remove this person from your school.
            </Link>
          </ModalTrigger>
        </p>
      </ReportToRemindSelectModal>
    );
  },

});

export default ReportOrgUserModal;



// WEBPACK FOOTER //
// ./src/organizations/components/ReportOrgUserModal.jsx